import { SwitchProjectRequestSchema, TenantsResponseSchema } from "@storytell/types";

export const GetTenantsResponseSchema = TenantsResponseSchema;

export const SwitchProjectInputSchema = SwitchProjectRequestSchema;
